import { useEffect } from 'react';

import { CardPlayerEnum } from 'modules/Room/constants/enums';
import GameFinishViews from 'modules/Room/game-status/components/game-finish-views/GameFinishViews';
import { GameStatusEnum } from 'modules/Room/game-status/constants/game-status-enum';
import { MintingEnum } from 'modules/Room/game-status/constants/game-status-enum';
import { useGameStatusStore } from 'modules/Room/game-status/store/game-status-store';

import { RoomStatusEnum } from 'shared/constants/shared-enums';
import { useRoomStore } from 'shared/store/roomStore';

import { InitGameStatuses } from './components/init-game-statuses';
import { PlayGameStatuses } from './components/play-game-statuses';

interface GameStatusProps {
  player?: CardPlayerEnum;
  isShowEndGameAnimation: boolean;
}

export const GameStatus = ({ player, isShowEndGameAnimation }: GameStatusProps) => {
  const { gameStatus, setMintingLoader } = useGameStatusStore();
  const { roomStatus } = useRoomStore();

  useEffect(() => {
    if (roomStatus === RoomStatusEnum.Closed) {
      setMintingLoader(MintingEnum.NONE);
    }
  }, [roomStatus]);

  if (isShowEndGameAnimation) return null;
  // todo: think how to refactor to remove hidden class, now exist because inside exist render logic
  // todo: return flex-grow for mobile, but fix it when pick a hand and small screen, also find solution when position absolute, to have space for rendered element

  return (
    <div className="relative z-50 flex w-full flex-grow items-center justify-center sm:static">
      <div
        className={`w-full p-4 hd:px-4 hd:py-0 ${
          gameStatus === GameStatusEnum.NONE &&
          roomStatus !== RoomStatusEnum.Closed &&
          roomStatus !== RoomStatusEnum.Open
            ? 'hidden'
            : ''
        }`}
      >
        <InitGameStatuses player={player} />
        <PlayGameStatuses player={player} />
        <GameFinishViews player={player} />
      </div>
    </div>
  );
};
